import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Add, Visibility } from '@material-ui/icons';

//tabla y card components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

import Modal from './Modal';
import { useToasty, Toasty } from 'hooks/Toasty';
import { Link } from 'react-router-dom';
import ButtonDelete from 'hooks/ButtonDelete';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Cód. Proveedor', accessor: 'CardCode', width: 140, align: 'center' },
  { Header: 'Nombre Proveedor', accessor: 'CardName' },
  { Header: 'Cód. Giro', accessor: 'code', width: 140, align: 'center' },
  { Header: 'Descripción giro', accessor: 'description' },
  { Header: 'Fec.Creación', accessor: 'created_at', width: 120, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default function ProviderCustomer() {
  const classes = useStyles();

  const [notify, showNotify] = useToasty();
  const [open, setOpen] = useState(false);

  const [providerLines, setProviderLines] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listProviderLines() {
    setDataLoading(true);
    let response = await wsGetAll('prom/provider-business-line');
    setDataLoading(false);
    if (response.success) setProviderLines(response.data);
  }

  useEffect(() => {
    listProviderLines();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      {open ? (
        <Modal open={open} setOpen={setOpen} showNotify={showNotify} reload={listProviderLines} />
      ) : undefined}
      <Card>
        <CardHeader icon>
          <CardIcon onClick={() => setOpen(true)} pointer="true" color="success">
            <Add />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de proveedor giro negocio {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="Proveedor-cliente"
            defaultWidth={1200}
            formatDate="DD-MM-YYYY"
            columns={columns}
            data={providerLines.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Link to={`${item.id}`}>
                      <Visibility />
                    </Link>
                    <ButtonDelete
                      entity="prom/provider-business-line"
                      id={{
                        provider_id: item.provider_id,
                        businessLines: [item.base_business_line_id],
                      }}
                      reload={listProviderLines}
                    />
                  </div>
                ),
                CardCode: item.CardCode,
                CardName: item.CardName,
                code: item.code,
                description: item.description,
                created_at: item.created_at,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
}
